import React from "react";
import { BadgeCheck, Star, Crown, Sparkles } from "lucide-react";

export function CreatorBadges({ badges = {}, size = "sm" }) {
  const items = [];
  if (badges.verified)
    items.push(
      <span key="v" data-testid="badge-verified" className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-semibold bg-emerald-100 text-emerald-800 border border-emerald-200">
        <BadgeCheck className="h-3.5 w-3.5" /> Verified
      </span>
    );
  if (badges.featured)
    items.push(
      <span key="f" data-testid="badge-featured" className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-semibold bg-indigo-100 text-indigo-800 border border-indigo-200">
        <Star className="h-3.5 w-3.5" /> Featured
      </span>
    );
  if (badges.founding)
    items.push(
      <span key="c" data-testid="badge-founding" className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-semibold bg-amber-100 text-amber-800 border border-amber-200">
        <Crown className="h-3.5 w-3.5" /> Founding
      </span>
    );
  if (!items.length) return null;
  return <div className="flex flex-wrap gap-1.5">{items}</div>;
}

export function ProBadge({ className = "" }) {
  return (
    <span data-testid="badge-pro" className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-semibold bg-gradient-to-r from-indigo-600 to-violet-600 text-white ${className}`}>
      <Sparkles className="h-3.5 w-3.5" /> Pro
    </span>
  );
}

export function GiftedTag() {
  return (
    <span data-testid="gifted-tag" className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-xs font-medium bg-indigo-50 text-indigo-700 border border-indigo-200">
      🎁 Gifted OK
    </span>
  );
}
